import { jsx as _jsx } from "react/jsx-runtime";
import { Grid as ChakraGrid, } from '@chakra-ui/react';
/**
 * Used to create grid layouts.
 * It renders a div with display: grid and comes with helpful style shorthand.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/grid
 */
export function Grid({ children, ...props }) {
    return _jsx(ChakraGrid, { ...props, children: children });
}
//# sourceMappingURL=grid.js.map